var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgVisa = function SvgVisa(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 42,
    viewBox: "0 0 60 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 3,
    width: 48,
    height: 30,
    rx: 2,
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.109 12.2123L20.2306 23.8244H17.0691L14.6922 14.5569C14.6699 14.3381 14.5908 14.129 14.463 13.9502C14.3351 13.7713 14.1628 13.6288 13.963 13.5369C13.0188 13.0893 12.0239 12.7577 11 12.5492L11.0692 12.2123H16.1784C16.513 12.2087 16.8376 12.3264 17.0921 12.5436C17.3466 12.7608 17.5139 13.0628 17.563 13.3938L18.846 20.1137L21.9567 12.2123H25.109ZM37.5703 20.0583C37.5703 16.9938 33.3335 16.8276 33.3612 15.443C33.3612 15.0276 33.7673 14.5846 34.635 14.4738C35.6513 14.3742 36.6755 14.5529 37.598 14.9907L38.1242 12.5261C37.2197 12.1848 36.2618 12.0067 35.295 12C32.3274 12 30.2182 13.5784 30.2182 15.8399C30.2182 17.5107 31.7089 18.4384 32.8443 18.9968C33.9796 19.5553 34.4089 19.9199 34.4042 20.4414C34.4042 21.2214 33.4812 21.5629 32.6089 21.5768C31.5337 21.6015 30.4703 21.3488 29.5212 20.8429L28.9997 23.386C30.0586 23.7989 31.1862 24.0072 32.3227 23.9998C35.475 23.9998 37.5427 22.4445 37.5519 20.0306L37.5703 20.0583ZM45.3979 23.8198H48.1671L45.7441 12.2123H43.178C42.9083 12.2169 42.6458 12.3001 42.4228 12.4518C42.1998 12.6035 42.0259 12.817 41.9226 13.0661L37.395 23.8244H40.538L41.1657 22.0891H45.0195L45.3979 23.8198ZM42.038 19.7076L43.621 15.3507L44.5441 19.7076H42.038ZM29.4012 12.2123L26.9182 23.8244H23.9229L26.4013 12.2123H29.4012Z",
    fill: "#1A1F71"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd",
    x: 0,
    y: 0,
    width: 60,
    height: 42,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 1,
    operator: "dilate",
    "in": "SourceAlpha",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "effect2_dropShadow",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgVisa);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "visa.2b07dfdbe53e8614ffb136ec630b7623.svg";